/**
 * @generated SignedSource<<6cb0ebf2fe0b975c47fc44d4037c4721>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SitemapNested_sitemap$data = {
  readonly sitemapLinks: ReadonlyArray<{
    readonly items: ReadonlyArray<{
      readonly items: ReadonlyArray<{
        readonly label: string | null;
        readonly linkUrl: string | null;
        readonly title: string | null;
      } | null> | null;
      readonly linkUrl: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly linkUrl: string | null;
    readonly linksType: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly " $fragmentType": "SitemapNested_sitemap";
};
export type SitemapNested_sitemap$key = {
  readonly " $data"?: SitemapNested_sitemap$data;
  readonly " $fragmentSpreads": FragmentRefs<"SitemapNested_sitemap">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SitemapNested_sitemap",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SitemapLink",
      "kind": "LinkedField",
      "name": "sitemapLinks",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linksType",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "linkItems",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "l3LinkItems",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Sitemap",
  "abstractKey": null
};
})();

(node as any).hash = "e08b71cfc4c90151c4bfec3ff304bbcc";

export default node;
